import React, { useCallback, useEffect } from "react";

const CelloLandingScreen = (props) => {
    const initializeCelloAttribution = useCallback(() => {
        if (!window.CelloAttribution) {
            console.log("Initializing CelloAttribution...");

            window.CelloAttribution = async function (t, ...o) {
                console.log(`CelloAttribution called with command: ${t}`, { args: o });

                if (t === "getReferral") {
                    console.error("getReferral is not supported in this context. Use getUcc instead.");
                    throw new Error("getReferral is not supported in this context. Use getUcc instead.");
                }

                let resolve, reject;
                const promise = new Promise((res, rej) => {
                    resolve = res;
                    reject = rej;
                });

                if (!window.CelloAttributionCmd) {
                    console.log("Initializing CelloAttributionCmd queue...");
                    window.CelloAttributionCmd = [];
                }

                window.CelloAttributionCmd.push({
                    command: t,
                    args: o,
                    resolve,
                    reject,
                });

                console.log("Command pushed to CelloAttributionCmd:", {
                    command: t,
                    args: o,
                });

                console.log("Current CelloAttributionCmd queue:", window.CelloAttributionCmd);
                console.log(promise);
                return promise;
            };

            console.log("CelloAttribution successfully initialized.");
        } else {
            console.log("CelloAttribution is already initialized.");
        }
    }, []);

    useEffect(() => {
        const fetchUcc = async () => {
            console.log("Initializing CelloAttribution...");
            await initializeCelloAttribution();

            console.log("Checking window.CelloAttribution...");
            console.dir(window.CelloAttribution);

            if (typeof window.CelloAttribution !== "function") {
                console.error("CelloAttribution function is not defined");
                return;
            }

            console.log("Current CelloAttributionCmd:", window.CelloAttributionCmd);

            console.log("Attempting to call getUcc...");
            try {
                const ucc = await window.CelloAttribution("getUcc");
                console.log("Current CelloAttributionCmd:", window.CelloAttributionCmd);
                console.log("UCC:", ucc);
                window.location.href = "https://www.pathway-solutions.de/";
            } catch (error) {
                console.error("Error fetching UCC:", error);
            }
        };

        fetchUcc();
    }, [initializeCelloAttribution]);

    return <div></div>;
};

CelloLandingScreen.propTypes = {};

export default CelloLandingScreen;
